import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
    GET_INVENTORY_PREFERENCE,
    GET_INVENTORY_PREFERENCE_SUCCESS,
    GET_INVENTORY_PREFERENCE_FAILURE,
    SET_SETS_FILTER_DATA,
    SET_SETS_SEARCHBAR_TEXT,
} from '../actions';

const initialState = {
    loading: false,
    data: null,
    error: null,
    setsSearchParams: {},
    searchbarText: {},
};

const inventoryPreferenceReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_INVENTORY_PREFERENCE:
            return { ...state, loading: true, error: null };
        case GET_INVENTORY_PREFERENCE_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_INVENTORY_PREFERENCE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SET_SETS_FILTER_DATA:
            return { ...state, setsFilterData: action.payload };
        case SET_SETS_SEARCHBAR_TEXT:
            return {
                ...state,
                searchbarText: {
                    ...state.searchbarText,
                    [action.payload?.filterType]: action.payload?.value ?? '',
                },
            };
        case 'SET_SETS_SEARCH_PARAMS':
            return { ...state, setsSearchParams: action.payload };
        default:
            return state;
    }
};

export default persistReducer(
    {
        key: 'inventoryPreferenceKey',
        storage,
        whitelist: ['setsFilterData'],
    },
    inventoryPreferenceReducer
);
